import React from "react";
import { Outlet } from "react-router-dom";
import { Helmet } from "react-helmet";

const OrderView = () => {
  return <Outlet />;
};

export default OrderView;
